import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import iconPhoto from './img/foto.png';
import iDel from './img/iDel.png';
import warning from './img/warning.png';
import './styles.scss';

const imgFormat = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif'
];

class addCarImgField extends Component {
  constructor () {
    super();
    this.state = {
      modalErrorShow: false,
      modalErrorMessage: '',
      fileName: ''
    };
  }
  hideModal = () => {
    this.setState({
      fileName: '',
      modalErrorShow: false,
      modalErrorMessage: ''
    });
  }
  checkDownloadFiles = (e) => {
    let errorMessage = '';
    const fileArray = Object.keys(e.target.files);
    console.log(e.target.files);
    console.log({ input: e.target });
    if (Object.keys(e.target.files).length + this.props.carsImgs.length > 12) {
      errorMessage = 'The maximum number of pictures to download should not exceed 12 pcs.';
      this.setState({
        fileName: '',
        modalErrorShow: true,
        modalErrorMessage: errorMessage
      });
      e.target.value = '';
      return false;
    }
    const fileFormatSize = fileArray.every((element) => {
      console.log(e.target.files[element].type);
      if (imgFormat.indexOf(e.target.files[element].type) === -1) {
        errorMessage = ' - file format is not supported (available file formats:png, gif, jpeg, jpg)';
        this.setState({
          fileName: e.target.files[element].name,
          modalErrorShow: true,
          modalErrorMessage: errorMessage
        });
        e.target.value = '';
        return false;
      }
      if (e.target.files[element].size > 2097152) {
        errorMessage = ' - file size exceeds the allowed size (max file size is 2 Mb)';
        this.setState({
          fileName: e.target.files[element].name,
          modalErrorShow: true,
          modalErrorMessage: errorMessage
        });
        e.target.value = '';
        return false;
      }
      return true;
    });
    if (!fileFormatSize) return fileFormatSize;
    return true;
  }
  downloadFiles = (e) => {
    const check = this.checkDownloadFiles(e);
    if (check) this.props.uploadImgHandl(e);
    console.log(check);
  }
  render() {
    return (
      <div className="body-addCarImgField">
        {this.props.carsImgs.length < 12 ?
          <form className="input-imgFile">
            <input
              name="filesToUpload[]"
              className="input-imgFileButton"
              type="file"
              accept="image/*"
              // onChange={this.props.uploadImgHandl}
              onChange={this.downloadFiles}
              multiple="multiple"
            />
            <img className="buttonImg-addCarImgField" src={iconPhoto} alt="Photo_pic" />
            <span className="name-addCarImgField">ADD A PHOTO</span>
          </form>
        : ''
        }
        {
          this.props.carsImgs.length > 0 ?
          this.props.carsImgs.map(element =>
            (
              <div key={element} className="imageContainer-addCarImgField">
                <button className="button-imageContainer-addCarImgField" onClick={() => this.props.delImgHandl(element)}>
                  <img src={iDel} alt="del_ico" className="delImage-addCarImgField" />
                </button>
                <img src={element} alt="car_photo" />
              </div>)) : ''
        }
        {
          this.state.modalErrorShow ?
            (
              <div className="modalError-addCarImgField">
                <div className="modalErrorBody-addCarImgField">
                  <img src={warning} alt="warning_pic" />
                  <p><span>{this.state.fileName}</span>{this.state.modalErrorMessage}</p>
                  <button className="button-addCarImgField" onClick={this.hideModal}>OK</button>
                </div>
              </div>
            ) : ''
        }
      </div>
    );
  }
}

addCarImgField.propTypes = {
  uploadImgHandl: PropTypes.func.isRequired,
  carsImgs: PropTypes.instanceOf(Array).isRequired,
  delImgHandl: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  carsImgs: state.careditor.pagesData.addCar.data.media.photo_links
});

export default connect(mapStateToProps, null)(addCarImgField);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/addCar/components/addCarImgField/index.js